/**
 * 服务支付协议
 */
export const ServicePaymentAgreementUrl =
  "https://actstatic.insnail.com/damselfish/common/20250701_12Times%E4%BA%A7%E5%93%81%E6%9C%8D%E5%8A%A1%E6%94%AF%E4%BB%98%E5%8D%8F%E8%AE%AE.pdf";

export const AliPayId = "ALIPAY_PAY_ID";

export enum ResponseCode {
  Success = 200,
}
